import React from 'react';
import { ArrowRight } from 'lucide-react';
import { steps } from './DataLifecycleSection';

const SolutionDetailsSection = ({ activeStep, onNavigate }) => {
    // Handle navigation to other pages
    const handleNavigate = (path) => {
        if (onNavigate) {
            onNavigate(path);
        }
    };

    return (
        <section className="relative z-10 py-20 px-4 bg-gradient-to-b from-slate-900 to-slate-800/70">
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
                    <div className="lg:col-span-2">
                        <div className="relative aspect-square">
                            <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/30 to-indigo-500/30 rounded-full blur-2xl opacity-20"></div>
                            <div className={`relative w-full h-full flex items-center justify-center rounded-full border-8 border-blue-500/30 p-8`}>
                                <div className={`absolute inset-2 rounded-full bg-gradient-to-r ${steps[activeStep].color} opacity-10 animate-pulse`}></div>

                                {/* Oil drop animation for current step */}
                                <div className="relative z-10 flex items-center justify-center w-full h-full">
                                    <div className="bg-slate-900/80 p-12 rounded-full relative overflow-hidden">
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <div className="w-full h-full bg-gradient-to-b from-transparent to-blue-500/20"></div>
                                        </div>
                                        <div className="relative z-10">
                                            {steps[activeStep].icon}
                                        </div>
                                    </div>
                                </div>

                                {/* Animated small oil drops */}
                                <div className="absolute top-1/4 left-1/4 w-4 h-4 bg-blue-500 rounded-full animate-ping opacity-70" style={{ animationDuration: '3s' }}></div>
                                <div className="absolute bottom-1/3 right-1/4 w-3 h-3 bg-indigo-500 rounded-full animate-ping opacity-70" style={{ animationDuration: '2.5s', animationDelay: '0.5s' }}></div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="inline-block px-3 py-1 bg-blue-900/30 rounded-full text-blue-400 text-sm font-medium mb-4 border border-blue-700/30">
                            Premium Data Refinery
                        </div>
                        <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent">
                            {steps[activeStep].title}
                        </h2>
                        <p className="text-xl text-slate-300 leading-relaxed mb-6">
                            {steps[activeStep].description}
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                            {steps[activeStep].features.map((feature, index) => (
                                <div key={index} className="flex items-start bg-slate-800/50 p-4 rounded-lg border border-slate-700/50">
                                    <div className={`bg-blue-500/20 p-2 rounded-lg mr-3`}>
                                        <div className="w-6 h-6 text-blue-400">
                                            {feature.icon}
                                        </div>
                                    </div>
                                    <p className="text-slate-300">{feature.text}</p>
                                </div>
                            ))}
                        </div>

                        <button
                            onClick={() => handleNavigate(steps[activeStep].link)}
                            className={`px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg 
                            text-base font-semibold transition-all duration-300 shadow-lg hover:shadow-blue-500/30 flex items-center text-white`}
                        >
                            Explore Our {steps[activeStep].title} Platform
                            <ArrowRight className="w-5 h-5 ml-2" />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SolutionDetailsSection;